export default __webpack_public_path__ + "static/worker-using-machine-light-d5bc88f9e0784ae1f9bd36dc978e4dac.jpg";